import type { PaymentPromotionFromBackend, PaymentPromotionsFromBackend, TransformedPaymentPromotion } from './types';

export function transformPaymentPromotions(
  paymentPromotions: PaymentPromotionsFromBackend,
): TransformedPaymentPromotion[] {
  return paymentPromotions.data.map(({ id, attributes }) => createPaymentPromotion(id, attributes));
}

function createPaymentPromotion(
  id: number,
  attributes?: PaymentPromotionFromBackend['attributes'],
) {
  const bannerUrl = attributes?.banner.data.attributes.url || '';
  const requireNoTransactions = attributes?.requireNoTransactions || false;

  return { id, bannerUrl, requireNoTransactions };
}
